export function harmonyProductData(originalPrice, discount, percent, specialBuy, specialPrice, someSkusHaveZeroPrice) {
  return {
    configuredPrice: {
      pricing: {
        alternate: {
          bulk: {
            value: null,
            thresholdQuantity: null,
          },
          unit: {
            unitsPerCase: null,
            caseUnitOfMeasure: null,
            unitsOriginalPrice: null,
            value: null,
          }
        },
        alternatePriceDisplay: false,
        mapAboveOriginalPrice: null,
        message: null,
        original: originalPrice,
        preferredPriceFlag: null,
        promotion: {
          dates: {
            start: null,
            end: null,
          },
          dollarOff: discount,
          percentageOff: percent,
          savingsCenter: specialBuy,
          savingsCenterPromos: null,
          specialBuySavings: null,
          specialBuyDollarOff: null,
          specialBuyPercentageOff: null,
          type: "DISCOUNT",
        },
        specialBuy: null,
        unitOfMeasure: "each",
        value: specialPrice,
        someSkusHaveZeroPrice,
      }
    }
  };
}
